module.exports = __webpack_public_path__ + "static/media/rugby.6f5a8e58.png";